import { useEffect, useState } from 'react';
import {obtenerProyectos,ingresarProyecto,obtenerProyecto,actualizarProyecto,deshabilitarProyecto} 
from '../data/Proyectos';
    
import { useContext } from "react";
import { AuthContext } from "auth";
import moment from 'moment';
import 'moment/locale/es';

export const useProyectos= (proyectoId) => {
    var {user}= useContext(AuthContext);

    const [proyectos,setProyectos]=useState();
    const [respuestaIngresarProyecto, setRespuestaIngresarProyecto] = useState({mensajeTexto:"",estado:false});

    const [proyectoPorActualizar, setProyectoPorActualizar] = useState({});
    const [respuestaActualizarProyecto, setRespuestaActualizarProyecto] = useState({mensajeTexto:"",estado:false});
    
    const updateRespuestaIngresarProyecto=async =>{
        setTimeout(function() {
            setRespuestaIngresarProyecto({mensajeTexto:"",estado:false});
        }, 4000);
    }
    const updateRespuestaActualizarProyecto=async =>{
        setTimeout(function() {
            setRespuestaActualizarProyecto({mensajeTexto:"",estado:false});
        }, 4000);
    }
    const getProyectos= async() => {
        const respuesta=await obtenerProyectos(user.Token);
        setProyectos(respuesta)
    }
    const getProyecto= async() => {
        const respuesta=await obtenerProyecto(proyectoId,user.Token);
        
        setProyectoPorActualizar(respuesta)
    }
  
    const insertProyecto=async(ProyectoPorIngresar)=>{
        
        if(ProyectoPorIngresar!=null){
            const respuesta=await ingresarProyecto(ProyectoPorIngresar,user.Token);
            if(respuesta!=undefined)
            {
                setRespuestaIngresarProyecto({estado:respuesta.success,mensajeTexto:respuesta.message})
            }
            else
            {
                setRespuestaIngresarProyecto({estado:false,mensajeTexto:"Se produjo un error"})
            }
            
            return respuesta;
        }
    }
    const updateProyecto=async(ProyectoPorActualizar)=>{
        
        if(ProyectoPorActualizar!=null){
            ProyectoPorActualizar.ProyectoId=proyectoId;
            const respuesta=await actualizarProyecto(ProyectoPorActualizar,user.Token);
            if(respuesta!=undefined)
            {
                setRespuestaActualizarProyecto({estado:respuesta.success,mensajeTexto:respuesta.message})
            }
            else
            {
                setRespuestaActualizarProyecto({estado:false,mensajeTexto:"Se produjo un error"})
            }
            
            return respuesta;
        }
    }
    const disabledProyecto=async(Id) =>{
        if(Id!=undefined && Id!=''){
            const respuesta=await deshabilitarProyecto(Id,user.Token);
            //setDisable(true)
            return respuesta;
        }
    }
    useEffect( () => {
        async function setProyectosFuncion(){
            getProyecto();
        }
        setProyectosFuncion();
    }, []); 

    return {
        proyectos,
        getProyectos,
        updateRespuestaIngresarProyecto,
        insertProyecto,
        respuestaIngresarProyecto,
        updateProyecto,
        proyectoPorActualizar,
        respuestaActualizarProyecto,
        setProyectoPorActualizar,
        updateRespuestaActualizarProyecto,
        disabledProyecto
    }
}
